import { Controller } from "@hotwired/stimulus"

// Month grid: show as many event chips per day as the cell can hold, then a
// "+N more" link for the rest. The server renders up to eight chips per day and
// the real count in data-total; this hides the ones that overflow, so a taller
// window (or fewer events) shows more instead of a fixed three.
export default class extends Controller {
    connect() {
        this.observer = new ResizeObserver(() => this.schedule())
        this.observer.observe(this.element)
        this.schedule()
    }

    disconnect() {
        this.observer?.disconnect()
        cancelAnimationFrame(this.frame)
    }

    schedule() {
        cancelAnimationFrame(this.frame)
        this.frame = requestAnimationFrame(() => this.fit())
    }

    fit() {
        this.element.querySelectorAll(".cal-chips").forEach((box) => {
            let chips = [...box.querySelectorAll(".cal-chip")]
            let more = box.querySelector(".cal-more")
            let total = Number(box.dataset.total) || chips.length
            chips.forEach((chip) => (chip.hidden = false))
            if (!more) return
            more.hidden = total <= chips.length
            // Narrow layout hides the chips entirely (dots instead): nothing to fit.
            if (box.clientHeight === 0) return

            let overflows = () => box.scrollHeight > box.clientHeight + 1
            if (!overflows() && total <= chips.length) return

            more.hidden = false
            let visible = chips.length
            more.textContent = `+${total - visible} more`
            while (visible > 0 && overflows()) {
                visible -= 1
                chips[visible].hidden = true
                more.textContent = `+${total - visible} more`
            }
        })
    }
}
